import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const BusinessPage = lazy(() => import('../pages/business/page'));
const ImportLicensePage = lazy(() => import('../pages/import-license/page'));
const OverseasPage = lazy(() => import('../pages/overseas/page'));
const MagazinePage = lazy(() => import('../pages/magazine/page'));
const CosmeticsPage = lazy(() => import('../pages/cosmetics/page'));
const SerafumePage = lazy(() => import('../pages/serafume/page'));
const HeallenPage = lazy(() => import('../pages/heallen/page'));
const DonggubaPage = lazy(() => import('../pages/donggubat/page'));
const PartnersPage = lazy(() => import('../pages/partners/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/business',
    element: <BusinessPage />,
  },
  {
    path: '/import-license',
    element: <ImportLicensePage />,
  },
  {
    path: '/overseas',
    element: <OverseasPage />,
  },
  {
    path: '/magazine',
    element: <MagazinePage />,
  },
  {
    path: '/cosmetics',
    element: <CosmeticsPage />,
  },
  {
    path: '/serafume',
    element: <SerafumePage />,
  },
  {
    path: '/heallen',
    element: <HeallenPage />,
  },
  {
    path: '/donggubat',
    element: <DonggubaPage />,
  },
  {
    path: '/partners',
    element: <PartnersPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
